import React from 'react';

export const EditIcon = ({
  width = 18,
  height = 18,
  className,
  style,
  fill = '#E1F4D3',
  stroke = '#1C452B',
  ...rest
}) => {
  const size = typeof width === 'number' ? width : 18;
  const sizeH = typeof height === 'number' ? height : 18;
  const combinedStyle = {
    width: size,
    height: sizeH,
    minWidth: size,
    minHeight: sizeH,
    flexShrink: 0,
    ...style,
  };
  return (
    <svg
      width={size}
      height={sizeH}
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={combinedStyle}
      {...rest}
    >
      <g clipPath="url(#clip0_edit_icon)">
        <path d="M42.7991 5.52249L33.1348 15.1869L46.941 28.9931L52.4635 23.4706C53.3839 21.1696 55.2248 15.7391 55.2248 12.4256C55.2248 9.11211 46.941 6.44291 42.7991 5.52249Z" fill={fill} />
        <mask id="mask0_edit_icon" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="67" height="67">
          <path d="M66.27 -3.05176e-05H0V66.2699H66.27V-3.05176e-05Z" fill="white" />
        </mask>
        <g mask="url(#mask0_edit_icon)">
          <path d="M47.9622 28.0802L51.6623 24.1593C55.5833 20.0175 57.3505 15.2957 51.2481 9.52473C45.1457 3.78133 40.5345 5.79704 36.6135 9.93892L13.9435 33.9341C13.0875 34.8453 12.2591 36.6401 12.0935 37.8826L11.0718 46.8291C10.7128 50.0597 13.0323 52.2687 16.2353 51.7165L25.1265 50.1978C26.3691 49.9769 28.1088 49.0657 28.9648 48.1269L39.8718 36.5849" stroke={stroke} strokeWidth="3.64" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M32.8311 13.9464C34.0184 21.5675 40.2036 27.3937 47.8799 28.1669" stroke={stroke} strokeWidth="3.64" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M8.2832 60.7475H38.6569" stroke={stroke} strokeWidth="3.64" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M49.7021 60.7475H57.9859" stroke={stroke} strokeWidth="3.64" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_edit_icon">
          <rect width="66.27" height="66.27" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
